import {
    ACCOUNT_DETAIL_CHECKED_VALUES
} from './actionTypes';

export function checkedValues(values) {
    return {
        type: ACCOUNT_DETAIL_CHECKED_VALUES,
        values
    }
}